import React, {Component} from 'react';
import {
  Row,
  Col,
  Grid,
  Panel,
  Table,
  PanelBody,
  PanelHeader,
  PanelContainer,
  Icon,
  Button,
  PanelFooter,
  Modal,
} from '@sketchpixy/rubix';

import moment from 'moment';
import {
  getPatientDetail,
  resetPassword
} from '../../api/api';
import {checkRole} from '../../util/RoleChecker';
import RoleType from '../RoleGroup/Roles/RoleType';
import ContractInfo from './ContractInfo';
import GenderType from '../../constants/GenderType';
import ChangePatientInfoModal from './ChangePatientInfoModal';
import {ClipLoader} from 'react-spinners';
import {css} from 'react-emotion';

const ClipLoaderOverride = css`
    display: block;
    margin-top: 150px;
    border-color: red;
`;

const DATE_FORMAT = 'YYYY.MM.DD';

export default class Detail extends Component {
  constructor(props) {
    super(props);

    const patientId = parseInt(props.params.patientId);

    this.state = {
      subscriptionList: null,
      patientId,
      name: null,
      birth: null,
      gender: GenderType.MALE,
      patientEmail: null,
      patientPhone: null,
      patientMobileNo: null,
      buyerMobileNo: null,
      country: null,
      latestLoginTime: null,
      totalPlayedTime: null,
      showChangeEmailModal: false,
      enableSerialLogin: false,
      loading: false
    };
  }

  showChangeEmailModal = () => {
    this.setState({
        showChangeEmailModal: true,
    });
  };
  
  closeChangeEmailModal = (result) => {
    this.setState({
        showChangeEmailModal: false,
    });

    if(result)
    {
      this.getPatientDetail();
    }
  };

  showLoading = () => {
    this.setState({ loading: true });
  };

  hideLoading = () => {
      this.setState({ loading: false });
   };

  componentDidMount() {
    Messenger.options = {
      theme: 'flat',
    };

    const requiredRoles = [
      RoleType.B2C_PATIENT_LIST,
      RoleType.B2C_PATIENT_LIST_READ_ONLY,
    ];

    checkRole(requiredRoles, this.props.router);

    let roles = JSON.parse(localStorage.getItem('roles'));
    let roleRegion = null;

    requiredRoles.forEach(requiredRoleType => {
      roles.forEach(role => {
        if (role.roleType && RoleType.enumValueOf(role.roleType.name) === requiredRoleType) {
          roleRegion = role.region;
        }
      });
    });

    this.getPatientDetail();
  }

  getPatientDetail() {
    this.showLoading();
    getPatientDetail(this.state.patientId, (err, result) => {
      this.hideLoading();
      if (err) {
        Messenger().post({
          type: 'error',
          message: `${err.message} (${err.statusCode})`,
          showCloseButton: true,
        });
      } else {
        let patient = result.patient;
        const subscriptionList = result.patientSubscriptions;
        const name = patient.patientNickname ? patient.patientNickname : `${patient.patientFirstName} ${patient.patientLastName}`;

        let latestLoginTime = (patient.latestLoginTime ? moment(patient.latestLoginTime).format(DATE_FORMAT) : '');
        let totalPlayedTime = this.secondsToTime(patient.totalPlayedTime);

        this.setState({
          name,
          birth:               patient.patientBirthday,
          gender:              GenderType.enumValueOf(patient.patientGender),
          patientEmail:        patient.patientEmail,
          buyerEmail:          patient.buyerEmail,
          patientMobileNo:     patient.patientMobileNo,
          buyerMobileNo:       patient.buyerMobileNo,
          country:             patient.countryCode,
          enableSerialLogin :  patient.enableSerialLogin,
          latestLoginTime:     latestLoginTime,
          totalPlayedTime:     totalPlayedTime,
          subscriptionList,
        });
      }
    });
  }
  
  secondsToTime = (secs) => {
        if(secs === null || Number.isNaN(secs)) return '';

        var sec_num = parseInt(secs, 10);
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if(seconds > 30) //반올림 
        {
           minutes+=1;
        }

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+' Hours '+minutes+' Minutes'; // +seconds  + ' Seconds';
  }



  goBack = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.props.router.goBack();
  };

  resetPassword = (e) => {
    e.preventDefault();
    e.stopPropagation();
    this.showLoading();
    resetPassword(this.state.patientId, (err, result) => {
        this.hideLoading();
        if (err) {
            Messenger().post({
              type: 'error',
              message: `${err.message} (${err.statusCode})`,
              showCloseButton: true,
            });
        } else {
            Messenger().post({
              type: 'success',
              message: 'successfully sent a password reset link!',
              showCloseButton: true,
            });
        }
    });
  };

  render() {
    return (
        <PanelContainer controls={false}>
          <Panel>
            <PanelHeader className="bg-pinkishred fg-white">
              <Grid>
                <Row>
                  <Col xs={12}>
                    <h3>
                      <Icon glyph="icon-fontello-torso" />
                      &nbsp; {this.state.name}
                      <Button
                          bsStyle="brownishgray"
                          className="pull-right"
                          onClick={this.resetPassword}
                          style={{padding: '0 24px 0 24px'}}>Reset Password</Button>
                    </h3>
                  </Col>
                </Row>
              </Grid>
            </PanelHeader>
            <PanelBody style={{padding: 25, minHeight: '160vh'}}>
              <ClipLoader
                className={ClipLoaderOverride}
                sizeUnit={'%'}
                size={70}
                color={'#123abc'}
                loading={this.state.loading}>
              </ClipLoader>
              <Table>
                <thead>
                <tr>
                  <th>Patient information</th>
                  <th />
                </tr>
                </thead>
                <tbody>
                <tr>
                  <td>Patient's Email</td>
                  <td>{this.state.patientEmail}
                  <Button
                    bsStyle="brownishgray"
                    className="pull-right"
                    onClick={this.showChangeEmailModal}
                    style={{padding: '0 24px 0 24px'}}>Change Patient Info</Button>
                  </td>
                </tr>
                <tr>
                  <td>Patient's Phone</td>
                  <td>{this.state.patientMobileNo}</td>
                </tr>
                <tr>
                  <td>Buyer's Email</td>
                  <td>{this.state.buyerEmail}</td>
                </tr>
                <tr>
                  <td>Buyer's Phone</td>
                  <td>{this.state.buyerMobileNo}</td>
                </tr>
                <tr>
                  <td>Birth</td>
                  <td>{this.state.birth}</td>
                </tr>
                <tr>
                  <td>Gender</td>
                  <td>{this.state.gender.title}</td>
                </tr>
                <tr>
                  <td>Country</td>
                  <td>{this.state.country}</td>
                </tr>
                <tr>
                <td>Last login</td>
                <td>{this.state.latestLoginTime}</td>
                </tr>
                <tr>
                <td>Total Training </td>
                <td>{this.state.totalPlayedTime}</td>
                </tr>
                </tbody>
              </Table>
              <ContractInfo patientId={this.state.patientId}  hideLoading={this.hideLoading}  showLoading={this.showLoading}/>
            </PanelBody>
          </Panel>
          <ChangePatientInfoModal
          showModal={this.state.showChangeEmailModal}
          closeModal={this.closeChangeEmailModal}
          patientId={this.state.patientId}
          patientEmail={this.state.patientEmail}
          patientMobileNo={this.state.patientMobileNo}
          buyerMobileNo={this.state.buyerMobileNo}
          enableSerialLogin={this.state.enableSerialLogin}
          />
        </PanelContainer>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/patient/Detail.js